var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.26 10.5H15.26V11.5H13.26V10.5Z",
    fill: "#aa4f4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4ZM8.4 15L8 13.77H6.06L5.62 15H4L6.2 9H7.82L10 15H8.4ZM16.76 11.5C16.7641 11.6981 16.7281 11.895 16.6541 12.0788C16.5802 12.2627 16.4699 12.4296 16.3298 12.5698C16.1896 12.7099 16.0227 12.8202 15.8388 12.8941C15.655 12.9681 15.4581 13.0041 15.26 13H13.26V15H11.76V9H15.26C15.4581 8.99591 15.655 9.03192 15.8388 9.10586C16.0227 9.17979 16.1896 9.29013 16.3298 9.43024C16.4699 9.57035 16.5802 9.73734 16.6541 9.92118C16.7281 10.105 16.7641 10.3019 16.76 10.5V11.5ZM20 15H18.5V9H20V15Z",
    fill: "#aa4f4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42999 12.77H7.58999L7.00999 11.18L6.42999 12.77Z",
    fill: "#aa4f4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/apiIcon.4567c4f74a50b96d29a773bd5538db3e.svg";
export { ForwardRef as ReactComponent };